export default __webpack_public_path__ + "static/media/h-rl-a.98d043e9.png";